import { actionGenerator } from 'shared/utils/redux';

import {
  ENewbuildingLayoutOffersActionTypes,
  TNewbuildingLayoutOffersSetFavoritePayload,
  TSetFavoriteNewbuildingLayoutOffers,
} from '../newbuildingLayoutOffers/types';

export const newbuildingLayoutsFavorite: (
  payload: TNewbuildingLayoutOffersSetFavoritePayload,
) => TSetFavoriteNewbuildingLayoutOffers = actionGenerator<
  ENewbuildingLayoutOffersActionTypes.SetFavorite,
  TNewbuildingLayoutOffersSetFavoritePayload
>(ENewbuildingLayoutOffersActionTypes.SetFavorite);
